import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { IFolioUnidad } from '../models/foliounidades';
import { Ifolios } from '../models/foliosunidadesindividuales';
import { IUnidadessinfolio } from '../models/unidadesinfolio';
import { IfoliosCeCo } from '../models/foliosceco';
import { Icecoindividual } from '../models/cecoindividual';
import { ISinFolioCeCo } from '../models/sinfolioceco';
@Injectable({
  providedIn: 'root'
})
export class FoliocecoService {
  private apiUrl: string ='';
  constructor(private _http: HttpClient) {
    this.apiUrl = environment.SUrlgApi + 'FoliosCeCo';
  }

  getFolioUnidades(): Observable<IfoliosCeCo[]> {
    return this._http
      .get<IfoliosCeCo[]>(this.apiUrl + '/getfolioceco/' )
      .pipe(retry(1), catchError(this.handleError));
  }


 public guardarFolioRuta(data:any):Observable<any>{
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this._http.post<any>(this.apiUrl + '/pFoluni/',body,{'headers':headers});
   }

   public guardarFolioRutaeditar(data:any):Observable<any>{
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this._http.post<any>(this.apiUrl + '/pFoluniedit/',body,{'headers':headers});
   }

   getFolioUnidadesindividuales(id_ciudad_principal: number , id_ciudad_hm :number ): Observable<Icecoindividual[]> {
    const valores = {
      params: new HttpParams().
        set('id_ciudad_principal', id_ciudad_principal).
        set('id_ciudad_hm', id_ciudad_hm)
    };
    return this._http
      .get<Icecoindividual[]>(this.apiUrl + '/getfolindi/', valores )
      .pipe(retry(1), catchError(this.handleError));
  }



  getvalidacionsinfolios(num_anio: number , num_mes :number ): Observable<ISinFolioCeCo[]> {
    const valores = {
      params: new HttpParams().
        set('num_anio', num_anio).
        set('num_mes', num_mes)
    };
    return this._http
      .get<ISinFolioCeCo[]>(this.apiUrl + '/getvalidacionfolios/',valores )
      .pipe(retry(1), catchError(this.handleError));
  }


   getListadoFolioMensual(num_mes: number,num_anio:number): Observable<any[]> {
      const valores = {
        params: new HttpParams().
          set('num_mes', num_mes).
          set('num_anio', num_anio)
      };
      return this._http
        .get<any[]>(this.apiUrl + '/rptListadoFolioMensual',valores);
    }


  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
